import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class ServiceTypeListItem {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  code!: string | null;
  @IsString()
  @Expose()
  vat!: string;
  @IsOptional()
  @IsString()
  @Expose()
  unit!: string | null;
  @IsString()
  @Expose()
  documentType!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @Expose()
  @IsOptional()
  @IsString()
  description!: string | null;
  @Expose()
  @IsOptional()
  @IsNumber()
  recordStampId!: string | null;
  @Expose()
  @IsNumber()
  documentTypeId!: number | null;
  // @Expose()
  // @IsOptional()
  // @IsNumber()
  // fareBaseServiceId!: null | number;
  // @Expose()
  // @IsOptional()
  // @IsNumber()
  // feesAndTaxesServiceId!: null | number;
  // @Expose()
  // @IsString()
  // fiscalPrinterRegisterCode!: string;
  // @Expose()
  // @IsNumber()
  // fiscalPrinterRegisterId!: number;
  // @Expose()
  // @IsOptional()
  // gtu!: null;
  // @Expose()
  // @IsOptional()
  // @IsString()
  // invoiceComment!: null | string;
  // @Expose()
  // @IsBoolean()
  // isBooking!: boolean;
  // @Expose()
  // @IsBoolean()
  // isCommission!: boolean;
  // @Expose()
  // @IsOptional()
  // @IsString()
  // pkWiU!: string | "";
  // @Expose()
  // @IsBoolean()
  // serviceIsOnlyForThisOffice!: boolean;

  // @Expose()
  // @Type(() => Translation)
  // @IsArray()
  // @ValidateNested()
  // translations!: Array<Translation>;
}

export class ServiceTypesResponse extends GenericTableResponse<ServiceTypeListItem> {
  @Type(() => ServiceTypeListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ServiceTypeListItem>;
}

export type ServiceTypesCategorizedResponse = Array<ServiceTypeCategory>;

export class ServiceTypeCategory {
  @IsString()
  @Expose()
  label!: string;
  @IsString()
  @Expose()
  code!: string;
  @IsBoolean()
  @Expose()
  disabled!: boolean;
  @Type(() => ServiceTypeBookingEditor)
  @ValidateNested()
  @Expose()
  serviceTypes!: Array<ServiceTypeBookingEditor>;
}

export class ServiceTypeBookingEditor {
  @IsOptional()
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  code!: string | null;
  @IsString()
  @Expose()
  vat!: string;
  @IsBoolean()
  @Expose()
  disabled!: boolean;
  @IsBoolean()
  @Expose()
  enableFareBase!: boolean;
}
